<template>
  <div class="nuttrema-popover-question-alert">
    <el-popover
       ref="popover-question-alert"
       trigger="manual"
       v-model="popoverVisible"
      :placement="popoverPlacement"
      :width="popoverWidth"
      @hide="popoverVisible = false">
      <div class="el-popover__title">{{ $t(popoverTitle) }}</div>
      <div class="el-popover__text" v-if="popoverText">{{ $t(popoverText) }}</div>
      <div class="el-popover__action">
        <el-button size="mini" type="primary" @click="onConfirmClick">{{ $t('label.confirm') }}</el-button>
        <el-button size="mini" type="text" @click="onCancelClick">{{ $t('label.cancel') }}</el-button>
      </div>
    </el-popover>
    <el-button
       v-popover:popover-question-alert
      :loading="loading"
      :type="buttonType"
      :size="buttonSize"
      :icon="buttonIcon"
      :class="buttonClass"
      @click.stop="onButtonClick">
      <slot>
        {{ $t(buttonTitle) }}
      </slot>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-popover-question-alert',
  props: {
    buttonType: {
      type: String,
      required: false,
      default: 'primary',
    },
    buttonSize: {
      required: false,
      default: 'small',
    },
    buttonIcon: {
      type: String,
      required: false,
      default: null,
    },
    buttonTitle: {
      type: String,
      required: false,
      default: null,
    },
    buttonClass: {
      type: String,
      required: false,
      default: null,
    },
    popoverShouldShow: {
      type: Boolean,
      required: false,
      default: true,
    },
    popoverPlacement: {
      type: String,
      required: false,
      default: 'top-start',
    },
    popoverWidth: {
      type: String,
      required: false,
      default: '200',
    },
    popoverTitle: {
      type: String,
      required: false,
      default: 'label.are_you_sure',
    },
    popoverText: {
      type: String,
      required: false,
      default: null,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      popoverVisible: false,
    };
  },
  methods: {
    onButtonClick() {
      if (!this.popoverShouldShow) this.$emit('confirmed');
      else this.popoverVisible = true;
      console.log('onButtonClick', this.popoverVisible);
    },
    onConfirmClick() {
      this.popoverVisible = false;
      this.$emit('confirmed');
    },
    onCancelClick() {
      this.popoverVisible = false;
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>

  .nuttrema-popover-question-alert {
    position: relative;
    margin-right: 0.5em;

    &.is-no-mr {
      margin-right: 0;
    }
  }

  .el-popover {
    .el-popover__title {
      font-size: 1rem;
      font-weight: 500;
    }
    .el-popover__text {
      text-align: left;
      font-size: 0.9rem;
      word-break: break-word;
    }
    .el-popover__action {
      margin-top: 1em;
      text-align: right;
    }

      .el-button--full {
        width: 100%;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/alert/nuttrema-popover-question-alert.vue